<div class="w-100 d-flex pt-15px pl-15px">
  <!-- I couldn't get "open in new tab" to work without the "; true" in (click) -->
  <a
    (click)="globalVars.isLeftBarMobileOpen = false; (true)"
    [routerLink]="[link]"
    [queryParams]="_queryParamsForLink(link)"
    queryParamsHandling="merge"
    routerLinkActive
    #rla="routerLinkActive"
    [ngClass]="{
      'left-bar__dot-unread': isUnread,
      'left-bar__dot-inactive': !rla.isActive,
      'left-bar__dot-active': rla.isActive
    }"
  >
    ·
  </a>

  <div class="d-flex justify-content-center align-items-center">
    <!-- I couldn't get "open in new tab" to work without the "; true" in (click) -->
    <a
      class="cursor-pointer fs-15px text-grey5"
      (click)="globalVars.isLeftBarMobileOpen = false; (true)"
      [routerLink]="[link]"
      [queryParams]="_queryParamsForLink(link)"
      [routerLinkActive]="['font-weight-bold', 'fc-default']"
      queryParamsHandling="merge"
    >
      {{ buttonLabel }}
    </a>
    <div
      *ngIf="
        hasNotifications &&
        globalVars.messageResponse &&
        globalVars.messageResponse.NumberOfUnreadThreads != 0
      "
      class="ml-5px p-5x fs-15px notification"
    >
      {{
        globalVars.messageResponse.NumberOfUnreadThreads > 999
          ? '999+'
          : globalVars.messageResponse.NumberOfUnreadThreads
      }}
    </div>
  </div>
</div>
